import React from 'react'
import { Exercise } from '../types'
import EditExerciseButton from './EditExerciseButton'
import DeleteExerciseButton from './DeleteExerciseButton'
interface Props {
  exercise: Exercise
}

const ExerciseTile = ({ exercise }: Props) => {
  return (
    <div className="rounded-xl p-4 border border-lightBorder/10">
      <div className="text-14 font-semibold">{exercise.question_type}</div>
      <div className="h-2" />
      <div className="text-12 text-slateGray h-5 text-ellipsis overflow-hidden whitespace-nowrap">
        {exercise.question
          ?.replace(/<i>/g, '')
          .replace(/<\/i>/g, '')
          .replace(/&nbsp;/g, ' ')}
      </div>
      <div className="text-12 text-slateGray h-5 text-ellipsis overflow-hidden whitespace-nowrap">
        {exercise.answer
          ?.replace(/<i>/g, '')
          .replace(/<\/i>/g, '')
          .replace(/&nbsp;/g, ' ')}
      </div>
      <div className="h-1 border-b border-lightBorder/10" />
      <div className="h-4" />
      <div className="flex justify-end gap-2">
        <DeleteExerciseButton exercise={exercise} />
        <EditExerciseButton exercise={exercise} />
      </div>
    </div>
  )
}

export default ExerciseTile
